module.exports = __webpack_public_path__ + "static/profile-bf6c0ccae0850fe9d9f806fc0d3d4266.jpg";